export default "__VITE_ASSET__d71f8e57__"